import { COMPOSITE_FIELD_VALUE_SEP } from "src/common/constants/formConstants";
import { UTC } from "src/common/constants/constants";

export function getUTCDateTime(epoch: number | null): string | undefined {
    if (epoch != null) {
        const isoString = new Date(epoch).toISOString();
        const isoStringParts = isoString.split("T");
        const dateParts = isoStringParts[0].split("-");
        const date = dateParts[1] + "/" + dateParts[2] + "/" + dateParts[0];
        const timeParts = isoStringParts[1].split(":");
        const time = timeParts[0] + ":" + timeParts[1];
        return date + COMPOSITE_FIELD_VALUE_SEP + time;
    }
    return undefined;
}

export function getEpoch(dateStringInUTC: string): number {
    return new Date(dateStringInUTC + " " + UTC).getTime();
}

export function getFormattedUTCDateTime(epoch: number | null): string | undefined {
    if (!epoch) {
        return undefined;
    }
    return getUTCDateTime(epoch) + " UTC";
}

export function getUTCDate(epoch: number): string {
    const date: Date = new Date(epoch);
    return [date.getUTCMonth() + 1, date.getUTCDate(), date.getUTCFullYear()].join('/')
}